const getters = {
  theme: state => state.app.theme(),
};
export default getters;
